import React from 'react';
import { IIconProps } from '../interfaces';

const PresetWSCIIcon: React.FC<IIconProps> = ({
                                                 color = '#141414',       // Default color for the play triangle
                                                 bgColor = '#ffffff',   // Default color for the background circle
                                                 width = '15'             // Default width and height of the icon
                                             }) => (
    <svg width={width} height={width} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width={width} height={width} rx="1" fill="black"/>
        <path
            d="M3.96355 14.2068H1.91746C1.4114 14.2068 1 13.8973 1 13.5169V1.6135C1 1.23305 1.4114 0.923584 1.91746 0.923584H3.96355C4.46961 0.923584 4.88101 1.23305 4.88101 1.6135V13.5169C4.88101 13.8973 4.46961 14.2068 3.96355 14.2068Z"
            fill={bgColor}/>
        <path
            d="M8.45086 14.2068H6.40477C5.89871 14.2068 5.4873 13.8973 5.4873 13.5169V1.6135C5.4873 1.23305 5.89871 0.923584 6.40477 0.923584H8.45086C8.95692 0.923584 9.36832 1.23305 9.36832 1.6135V13.5169C9.36832 13.8973 8.95692 14.2068 8.45086 14.2068Z"
            fill={bgColor}/>
        <path
            d="M12.9394 14.2068H10.8933C10.3872 14.2068 9.97583 13.8973 9.97583 13.5169V1.6135C9.97583 1.23305 10.3872 0.923584 10.8933 0.923584H12.9394C13.4454 0.923584 13.8568 1.23305 13.8568 1.6135V13.5169C13.8568 13.8973 13.4454 14.2068 12.9394 14.2068Z"
            fill={bgColor}/>
        <path
            d="M5.18315 9.28411C4.23475 9.28411 3.46655 8.73408 3.46655 8.05532V0.714355H6.89976V8.05699C6.89976 8.73575 6.13156 9.28578 5.18315 9.28578V9.28411Z"
            fill={color}/>
        <path
            d="M9.66484 9.28411C8.71644 9.28411 7.94824 8.73408 7.94824 8.05532V0.714355H11.3814V8.05699C11.3814 8.73575 10.6133 9.28578 9.66484 9.28578V9.28411Z"
            fill={color}/>
    </svg>


);

export default PresetWSCIIcon;
